import { Helmet } from "react-helmet";

const Section = ({ title, children }) => (
  <div className="flex flex-col">
    <header className="text-center px-4">
      <h1 className="text-gold text-3xl">{title}</h1>
    </header>
    {children}
  </div>
);

const drivesContent = [
  {
    title: "Live Markets for Every Swing",
    body: (
      <p>
        <strong className="text-white">Drives Golf</strong> is the real-time
        evolution of “expected strokes.” We translate each shot’s lie, distance,
        and context into a live probability of finishing the hole at – or under
        – par. Fans can buy, sell, or hold that probability the moment the ball
        leaves the club.
      </p>
    ),
  },
  {
    title: "Why It’s Different",
    body: (
      <div>
        <p>
          Building live golf markets demands the industry’s most diverse data
          stack:
        </p>
        <ul className="list-disc text-left mt-3 w-full">
          <li>Historical performance for every course</li>
          <li>PGA ShotLink coordinates</li>
          <li>
            Course topology down to slope, green firmness, and hazard margins
          </li>
        </ul>
        <p>
          Our engine blends these feeds in milliseconds, turning what used to be
          a static expected strokes model into a tradable micro-market for each
          swing.
        </p>
      </div>
    ),
  },
  {
    title: "What It Unlocks",
    body: (
      <>
        <ul className="list-disc text-left w-full">
          <li>
            New betting inventory on approach shots, recovery shots, and putts
          </li>
          <li>
            Situational and shot values, instantly visualizing risk-reward
            decisions
          </li>
          <li>Data-driven commentary</li>
        </ul>
        <p>
          The result: a broadcast that breathes in real time, analysts armed
          with fresh insight, and sportsbooks with continuous handle from the
          first tee to the final tap-in. Drives Golf the next shot in golf
          engagement.
        </p>
      </>
    ),
  },
];

export default function Golf() {
  return (
    <section className="section about-section">
      <Helmet>
        <title>Golf</title>
      </Helmet>

      <div className="flex flex-col container">
        {drivesContent.map((data, index) => (
          <Section key={index} title={data.title} children={data.body} />
        ))}
      </div>
    </section>
  );
}
